export type PerformanceInsightsTab = 'loadTimes' | 'contentMetrics';

export type PerformanceInsightsStoreType = {
	selectedTab: PerformanceInsightsTab;
};

export type PerformanceInsightsActionType = {
	type: 'SELECT_TAB';
	payload: PerformanceInsightsTab;
};

export const buildInitialPerformanceInsightsStore = (): PerformanceInsightsStoreType => {
	return {
		selectedTab: 'loadTimes',
	};
};

export const performanceInsightsReducer = (
	state: PerformanceInsightsStoreType,
	action: PerformanceInsightsActionType,
): PerformanceInsightsStoreType => {
	if (action.type == 'SELECT_TAB') {
		return {
			...state,
			selectedTab: action.payload,
		};
	} else {
		return state;
	}
};
